/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Hero_TitleInputs */

const en_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for a student's budget`)
};

const es_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseñado para el presupuesto de un estudiante`)
};

/**
* | output |
* | --- |
* | "Built for a student's budget" |
*
* @param {Pricing_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_title = /** @type {((inputs?: Pricing_Hero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_hero_title(inputs)
	return en_pricing_hero_title(inputs)
});